<main>
  <kl-digital-assist-tasks (profileFullView)="ok()"></kl-digital-assist-tasks>
</main>